import { IconFilter2 } from '@calendly/ui/components/glyphs/IconFilter2'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { colorIconActive, colorIconStandard } from '@calendly/ui/theme'

export const FilterMenuTriggerIcon = ({ selected = false, icon = IconFilter2, ...props }) => (
  <UiIcon
    icon={icon}
    size="small"
    color={selected ? colorIconActive : colorIconStandard}
    title=""
    {...props}
  />
)
